import { MedicationCard } from 'src/app/components/Models/Medication/MedicationCard';
import type { HomeArchivedItem } from 'src/app/types';

import { TopMargin } from './styles';

interface ArchiveSectionProps {
  archivedHomescreenItems: HomeArchivedItem[];
  hasMultiplePatients: boolean;
}

export const ArchiveSectionContainer = ({ archivedHomescreenItems, hasMultiplePatients }: ArchiveSectionProps) => {
  return (
    <>
      {archivedHomescreenItems.map(item => {
        return (
          <TopMargin key={item.id}>
            <MedicationCard
              showSecondaryName={true}
              showPatientName={true}
              showInstructions={false}
              showCheckout={false}
              showDosage={true}
              showRefillCount={false}
              isArchivedSection={true}
              homeScreenItem={item}
              hasMultiplePatients={hasMultiplePatients}
              showMenuActions={true}
              goToMedDetailsOnMedNameClick={true}
            />
          </TopMargin>
        );
      })}
    </>
  );
};
